var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "carousel-wrapper" },
    [
      _c(
        "swiper",
        { ref: _vm.reference, attrs: { options: _vm.options } },
        _vm._l(_vm.slides, function(slide) {
          return _c("swiper-slide", { key: slide.id }, [
            _c("div", { staticClass: "block" }, [
              _c("p", {
                staticClass: "name",
                domProps: { innerHTML: _vm._s(slide.name) }
              }),
              _vm._v(" "),
              _c("p", { staticClass: "country" }, [
                _vm._v(_vm._s(slide.country))
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "percent" }, [
                _vm._v(_vm._s(slide.percent))
              ])
            ]),
            _vm._v(" "),
            slide.child
              ? _c("div", { staticClass: "block block-child" }, [
                  _c("p", {
                    staticClass: "name",
                    domProps: { innerHTML: _vm._s(slide.child.name) }
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "country" }, [
                    _vm._v(_vm._s(slide.child.country))
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "percent" }, [
                    _vm._v(_vm._s(slide.child.percent))
                  ])
                ])
              : _vm._e()
          ])
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }